import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-title-change',
  templateUrl: './title-change.component.html',
  styleUrls: ['./title-change.component.scss']
})
export class TitleChangeComponent implements OnInit {
  form!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private store: Store,
    public dialogRef: MatDialogRef<TitleChangeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {
      current: { ttlkbn: string, ttlcd: string },
      pending: { ttlkbn: string, ttlcd: string }
    }
  ) { }

  get titleList() {
    return this.store.selectSnapshot(SettingSelectors.scheduleTitleList);
  }

  get current() {
    return this.dialogData.current;
  }

  get pending() {
    return this.dialogData.pending;
  }

  get currentId() {
    let target = this.pending || this.current;
    return this.titleList.findIndex(x => x.ttlkbn === target?.ttlkbn && x.ttlcd === target?.ttlcd);
  }

  get disabledId() {
    return this.titleList.findIndex(x => x.ttlkbn === this.current?.ttlkbn && x.ttlcd === this.current?.ttlcd);
  }

  get saveDisabled() {
    let index = this.form.get('title')?.value;
    return index === this.disabledId;
  }

  cancelTxt = 'キャンセル';
  submitTxt = '保存';

  ngOnInit(): void {
    this.form = this.fb.group({ title: this.currentId });
  }

  submit() {
    let index = this.form.get('title')?.value;
    if (index == null) {
      this.dialogRef.close();
      return;
    }
    let title = this.titleList[index];
    this.dialogRef.close(title)
  }

}
